var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panel',[_c('v-expansion-panel-header',{class:_vm.b('title')},[_vm._v(_vm._s(_vm.subcategory.name))]),_c('v-expansion-panel-content',{staticClass:"pl-3"},[_c('file-list',{attrs:{"files":_vm.subcategory.items}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }